import { Body14Regular } from "@/components/typography/Body14Regular";
import { UserDto } from "@/types/dto/user-dto";
import { Table } from "flowbite-react";
import { Row } from "./Row";

interface Props {
  user: UserDto;
}

const headers = ["내 이름", "부서", "연락처", "이메일"];

export const AdminMyTable: React.FC<Props> = ({ user }) => {
  return (
    <div className="overflow-x-auto rounded-[4px]">
      <Table className="border">
        <Table.Head>
          {headers.map((title, index) => (
            <Table.HeadCell
              className={`w-[412px] h-[38px] p-0 border`}
              key={title}
            >
              <div className="flex box-border mx-[16px] my-[8px] h-[22px]">
                <Body14Regular className="text-semantic-text-secondary">
                  {title}
                </Body14Regular>
              </div>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          <Row key={user.id} user={user} />
        </Table.Body>
      </Table>
    </div>
  );
};
